import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../containers/TreatmentSummary/TreatmentSummary.i18n';

import { AllergyDetail } from './allergyDetail';
import { ChemotherapyDetail } from './chemotherapyDetail';
import { ClinicalTrialDetail } from './clinicalTrialDetail';
import { ComorbidityDetail } from './comorbidityDetail';
import { DiagnosisDetail } from './diagnosisDetail';
import { FamilyHistoryDetail } from './familyHistoryDetail';
import { GeneticTestDetail } from './geneticTestDetail';
import { GynecologicHistoryDetail } from './gynecologicHistoryDetail';
import { HormoneTherapyDetail } from './hormoneTherapyDetail';
import { InitialClinicalFindingDetail } from './initialClinicalFindingDetail';
import { OtherDetail } from './otherDetail';
import { RadiationTherapyDetail } from './radiationTherapyDetail';
import { SideEffectBundleDetail } from './sideEffectBundleDetail';
import { SocialHistoryDetail } from './socialHistoryDetail';
import { SurgeryDetail } from './surgeryDetail';
import { TransplantHistoryDetail } from './transplantHistoryDetail';
import { TumorMarkerDetail } from './tumorMarkerDetail';

export class TreatmentSummaryItemGroup extends React.Component {
  buildItemList() {
    switch (this.props.groupKey) {
      case 'Allergy':
        return this.props.items.map((allergy, idx) =>
          (<AllergyDetail key={`key-allergy-${idx}`} allergy={allergy}
            language={this.props.language} capabilities={this.props.capabilities}
          />)
        );
      case 'Chemotherapy':
        return this.props.items.map((chemotherapy, idx) =>
          (<ChemotherapyDetail key={`key-chemotherapy-${idx}`}
            chemotherapy={chemotherapy} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'ClinicalTrial':
        return this.props.items.map((clinicalTrial, idx) =>
          (<ClinicalTrialDetail key={`key-clinicalTrial-${idx}`}
            clinicalTrial={clinicalTrial} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'Comorbidity':
        return this.props.items.map((comorbidity, idx) =>
          (<ComorbidityDetail key={`key-comorbidity-${idx}`}
            comorbidity={comorbidity} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'Diagnosis':
        return this.props.items.map((diagnosis, idx) =>
          (<DiagnosisDetail key={`key-diagnosis-${idx}`}
            diagnosis={diagnosis}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'FamilyHistory':
        return this.props.items.map((familyHistory, idx) =>
          (<FamilyHistoryDetail key={`key-familyHistory-${idx}`}
            familyHistory={familyHistory}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'GeneticTest':
        return this.props.items.map((geneticTest, idx) =>
          (<GeneticTestDetail key={`key-geneticTest-${idx}`}
            geneticTest={geneticTest}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'GynecologicHistory':
        return this.props.items.map((gynecologicHistory, idx) =>
          (<GynecologicHistoryDetail key={`key-gynecologicHistory-${idx}`}
            gynecologicHistory={gynecologicHistory}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'HormoneTherapy':
        return this.props.items.map((hormoneTherapy, idx) =>
          (<HormoneTherapyDetail key={`key-hormoneTherapy-${idx}`}
            hormoneTherapy={hormoneTherapy} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'InitialClinicalFinding':
        return this.props.items.map((initialClinicalFinding, idx) =>
          (<InitialClinicalFindingDetail key={`key-initialClinicalFinding-${idx}`}
            initialClinicalFinding={initialClinicalFinding}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'Other':
        return this.props.items.map((other, idx) =>
          (<OtherDetail key={`key-other-${idx}`}
            other={other} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'RadiationTherapy':
        return this.props.items.map((radiationTherapy, idx) =>
          (<RadiationTherapyDetail key={`key-radiationTherapy-${idx}`}
            radiationTherapy={radiationTherapy} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'SideEffectBundle':
        return this.props.items.map((sideEffectBundle, idx) =>
          (<SideEffectBundleDetail key={`key-sideEffectBundle-${idx}`}
            sideEffectBundle={sideEffectBundle} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'SocialHistory':
        return this.props.items.map((socialHistory, idx) =>
          (<SocialHistoryDetail key={`key-socialHistory-${idx}`}
            socialHistory={socialHistory} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'Surgery':
        return this.props.items.map((surgery, idx) =>
          (<SurgeryDetail key={`key-surgery-${idx}`}
            surgery={surgery}
            language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'TransplantHistory':
        return this.props.items.map((transplantHistory, idx) =>
          (<TransplantHistoryDetail key={`key-transplantHistory-${idx}`}
            transplantHistory={transplantHistory} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      case 'TumorMarker':
        return this.props.items.map((tumorMarker, idx) =>
          (<TumorMarkerDetail key={`key-tumorMarker-${idx}`}
            tumorMarker={tumorMarker} language={this.props.language}
            capabilities={this.props.capabilities}
          />)
        );
      default:
        return ''; // do nothing
    }
  }

  displayGroup() {
    return (
      <div className="category-wrapper" data-qa={'group_' + this.props.groupKey} >
        <div className="category-header">
            <FormattedMessage {...messages.groups[this.props.groupKey]} />
        </div>
        {
          this.buildItemList()
        }
      </div>
    );
  }

  render() {
    // if no capabilities for this group, don't show it
    const returnValue = this.props.capabilities ? this.displayGroup() : null;
    return returnValue;
  }
}

TreatmentSummaryItemGroup.propTypes = {
  groupKey: PropTypes.string,
  items: PropTypes.array.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object,
};